/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Personalinfo1Inputs */

const zh_profile_personalinfo1 = /** @type {(inputs: Profile_Personalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人信息`)
};

const en_profile_personalinfo1 = /** @type {(inputs: Profile_Personalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Information`)
};

const es_profile_personalinfo1 = /** @type {(inputs: Profile_Personalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información personal`)
};

/**
* | output |
* | --- |
* | "Personal Information" |
*
* @param {Profile_Personalinfo1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_personalinfo1 = /** @type {((inputs?: Profile_Personalinfo1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Personalinfo1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_personalinfo1(inputs)
	if (locale === "en") return en_profile_personalinfo1(inputs)
	return es_profile_personalinfo1(inputs)
});
export { profile_personalinfo1 as "profile_personalInfo" }